<script>
  import { IS_PRODUCTION } from '../../config.js';

  export let user = null;
  export let isAdmin = false;
  export let isCompany = false;
  export let currentPage = 'home';
  export let isDropdownOpen = false;
  export let isAdminMenuOpen = false;
  export let onPageChange = () => {};
  export let onLogout = () => {};
  export let onToggleDropdown = () => {};
  export let onToggleMenu = () => {};
  export let onToggleAdminMenu = () => {};
  export let onLogoClick = () => {};
  export let isMenuOpen = false;

  // 관리자 메뉴 항목 클릭 시 드롭다운 닫기
  function handleAdminMenuClick(page) {
    onPageChange(page);
    onToggleAdminMenu();
  }
</script>

<header>
  <div class="logo">
    <button
      on:click={() => {
        onPageChange('home');
        onLogoClick();
      }}
      class="logo-button"
    >
      <div class="logo-container" class:dev-mode={!IS_PRODUCTION}>
        <img src={IS_PRODUCTION ? "/wideworkLogo.png" : "/wideworkLogo2.png"} alt="WIDE-WORK" class="logo-image" />
        {#if !IS_PRODUCTION}
          <span class="dev-badge">(지원자 개발 버전)</span>
        {/if}
      </div>
    </button>
  </div>
  <nav class="desktop-nav">
    <ul>
      <li><a href="#projects" class:active={currentPage === 'home'} on:click|preventDefault={() => onPageChange('home')}>프로젝트 찾기</a></li>
      <li><a href="/certificate-issue" class:active={currentPage === 'certificate-issue'} on:click|preventDefault={() => onPageChange('certificate-issue')}>증명서 발급</a></li>
      <li><a href="/how-to-use" class:active={currentPage === 'how-to-use'} on:click|preventDefault={() => onPageChange('how-to-use')}>이용방법</a></li>
      {#if isAdmin}
        <li class="admin-menu-dropdown">
          <button
            class="admin-menu-btn"
            class:active={['admin-dashboard', 'admin-users', 'admin-applicants', 'project-register', 'project-edit', 'common-codes', 'admin-email-template', 'admin-interviews', 'claude-dashboard'].includes(currentPage)}
            on:click={onToggleAdminMenu}
          >
            관리자 메뉴
            <span class="dropdown-arrow">{isAdminMenuOpen ? '▲' : '▼'}</span>
          </button>
          {#if isAdminMenuOpen}
            <div class="admin-dropdown-menu">
              <button class:active={currentPage === 'admin-dashboard'} on:click={() => handleAdminMenuClick('admin-dashboard')}>대시보드</button>
              <button class:active={currentPage === 'admin-users'} on:click={() => handleAdminMenuClick('admin-users')}>회원 관리</button>
              <button class:active={currentPage === 'admin-applicants'} on:click={() => handleAdminMenuClick('admin-applicants')}>지원자 관리</button>
              <button class:active={currentPage === 'project-register' || currentPage === 'project-edit'} on:click={() => handleAdminMenuClick('project-register')}>공고 등록</button>
              <button class:active={currentPage === 'common-codes'} on:click={() => handleAdminMenuClick('common-codes')}>공통 코드</button>
              <button class:active={currentPage === 'admin-email-template'} on:click={() => handleAdminMenuClick('admin-email-template')}>이메일 템플릿</button>
              <button class:active={currentPage === 'admin-interviews'} on:click={() => handleAdminMenuClick('admin-interviews')}>인터뷰 관리</button>
              <button class:active={currentPage === 'claude-dashboard'} on:click={() => handleAdminMenuClick('claude-dashboard')}>Claude 사용량</button>
              <button on:click={() => window.open('http://widework.cafe24.com:3030/', '_blank')}>배치 모니터 ↗</button>
            </div>
          {/if}
        </li>
      {/if}
      {#if isCompany && !isAdmin}
        <li><a href="/company-applicants" class:active={currentPage === 'company-applicants'} on:click|preventDefault={() => onPageChange('company-applicants')}>지원자 관리</a></li>
        <li><a href="/project-register" class:active={currentPage === 'project-register' || currentPage === 'project-edit'} on:click|preventDefault={() => onPageChange('project-register')}>공고 등록</a></li>
      {/if}
    </ul>
  </nav>
  <div class="auth-buttons">
    {#if user}
      <div class="user-dropdown">
        <button class="user-btn" on:click={onToggleDropdown}>
          <span>{isAdmin ? '[관리자] ' : isCompany ? '[기업] ' : ''}{user.name || user.email.split('@')[0]}님</span>
          <span class="dropdown-arrow">▼</span>
        </button>
        {#if isDropdownOpen}
          <div class="dropdown-menu">
            <button on:click={() => onPageChange('mypage')}>마이페이지</button>
            {#if isAdmin}
              <button on:click={() => onPageChange('admin-users')}>회원 관리</button>
              <button on:click={() => onPageChange('admin-applicants')}>지원자 관리</button>
              <button on:click={() => onPageChange('project-register')}>공고 등록</button>
              <!-- <button on:click={() => onPageChange('gemini-test')}>Gemini 테스트</button> -->
            {/if}
            {#if isCompany && !isAdmin}
              <button on:click={() => onPageChange('company-applicants')}>지원자 관리</button>
              <button on:click={() => onPageChange('project-register')}>공고 등록</button>
            {/if}
            <button on:click={onLogout}>로그아웃</button>
          </div>
        {/if}
      </div>
    {:else}
      <button class="login-btn" on:click={() => onPageChange('login')}>회원가입/로그인</button>
    {/if}
  </div>
  <button class="menu-btn" on:click={onToggleMenu}>
    <span class="menu-icon">≡</span>
  </button>
</header>

<!-- 모바일 메뉴 -->
{#if isMenuOpen}
  <div class="mobile-menu">
    <nav class="mobile-nav">
      <ul>
        <li><a href="#projects" class:active={currentPage === 'home'} on:click|preventDefault={() => { onPageChange('home'); onToggleMenu(); }}>프로젝트 찾기</a></li>
        <li><a href="/certificate-issue" class:active={currentPage === 'certificate-issue'} on:click|preventDefault={() => { onPageChange('certificate-issue'); onToggleMenu(); }}>증명서 발급</a></li>
        <li><a href="/how-to-use" class:active={currentPage === 'how-to-use'} on:click|preventDefault={() => { onPageChange('how-to-use'); onToggleMenu(); }}>이용방법</a></li>
        {#if isAdmin}
          <li><a href="/admin-dashboard" class:active={currentPage === 'admin-dashboard'} on:click|preventDefault={() => { onPageChange('admin-dashboard'); onToggleMenu(); }}>대시보드</a></li>
          <li><a href="/admin-users" class:active={currentPage === 'admin-users'} on:click|preventDefault={() => { onPageChange('admin-users'); onToggleMenu(); }}>회원 관리</a></li>
          <li><a href="/admin-applicants" class:active={currentPage === 'admin-applicants'} on:click|preventDefault={() => { onPageChange('admin-applicants'); onToggleMenu(); }}>지원자 관리</a></li>
          <li><a href="/project-register" class:active={currentPage === 'project-register' || currentPage === 'project-edit'} on:click|preventDefault={() => { onPageChange('project-register'); onToggleMenu(); }}>공고 등록</a></li>
          <li><a href="/admin-email-template" class:active={currentPage === 'admin-email-template'} on:click|preventDefault={() => { onPageChange('admin-email-template'); onToggleMenu(); }}>이메일 템플릿</a></li>
          <li><a href="/admin-interviews" class:active={currentPage === 'admin-interviews'} on:click|preventDefault={() => { onPageChange('admin-interviews'); onToggleMenu(); }}>인터뷰 관리</a></li>
          <li><a href="/claude-dashboard" class:active={currentPage === 'claude-dashboard'} on:click|preventDefault={() => { onPageChange('claude-dashboard'); onToggleMenu(); }}>Claude 사용량</a></li>
          <li><a href="http://widework.cafe24.com:3030/" target="_blank" rel="noopener">배치 모니터 ↗</a></li>
        {/if}
        {#if isCompany && !isAdmin}
          <li><a href="/company-applicants" class:active={currentPage === 'company-applicants'} on:click|preventDefault={() => { onPageChange('company-applicants'); onToggleMenu(); }}>지원자 관리</a></li>
          <li><a href="/project-register" class:active={currentPage === 'project-register' || currentPage === 'project-edit'} on:click|preventDefault={() => { onPageChange('project-register'); onToggleMenu(); }}>공고 등록</a></li>
        {/if}
        {#if user}
          <li><a href="/mypage" class:active={currentPage === 'mypage'} on:click|preventDefault={() => { onPageChange('mypage'); onToggleMenu(); }}>마이페이지</a></li>
          <li><a href="#!" on:click|preventDefault={() => { onLogout(); onToggleMenu(); }}>로그아웃</a></li>
        {:else}
          <li><a href="/login" class:active={currentPage === 'login'} on:click|preventDefault={() => { onPageChange('login'); onToggleMenu(); }}>회원가입/로그인</a></li>
        {/if}
      </ul>
    </nav>
  </div>
{/if}

<style>
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: white;
    border-bottom: 1px solid #e9ecef;
    position: sticky;
    top: 0;
    z-index: 1000;
  }

  .logo-button {
    background: none;
    border: none;
    padding: -10px -15px;
    margin: 0;
    font: inherit;
    cursor: pointer;
    color: inherit;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .logo-container {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .logo-image {
    height: 60px;
    width: auto;
    cursor: pointer;
    display: block;
  }

  .logo-container.dev-mode {
    position: relative;
  }

  .dev-badge {
    font-size: 12px;
    font-weight: 600;
    color: #dc2626;
    white-space: nowrap;
  }

  .desktop-nav ul {
    display: flex;
    align-items: center;
    list-style: none;
  }

  .desktop-nav li {
    margin-left: 30px;
  }

  .desktop-nav a {
    color: #333;
    text-decoration: none;
    font-weight: 500;
    padding: 8px 0;
    position: relative;
  }

  .desktop-nav a:hover,
  .desktop-nav a.active {
    color: #3273dc;
  }

  .desktop-nav a.active:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #3273dc;
  }

  /* 관리자 메뉴 드롭다운 스타일 */
  .admin-menu-dropdown {
    position: relative;
    display: flex;
    align-items: center;
  }

  .admin-menu-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: none;
    color: #333;
    font-weight: 500;
    font-size: inherit;
    cursor: pointer;
    padding: 8px 0;
    font-family: inherit;
    line-height: inherit;
  }

  .admin-menu-btn:hover,
  .admin-menu-btn.active {
    color: #3273dc;
  }

  .admin-menu-btn .dropdown-arrow {
    font-size: 0.7rem;
    transition: transform 0.2s ease;
  }

  .admin-dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-width: 160px;
    margin-top: 8px;
    z-index: 1100;
    overflow: hidden;
  }

  .admin-dropdown-menu button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 12px 16px;
    background: none;
    border: none;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    font-size: 0.9rem;
    color: #333;
    font-family: inherit;
    transition: background-color 0.15s ease;
  }

  .admin-dropdown-menu button:last-child {
    border-bottom: none;
  }

  .admin-dropdown-menu button:hover {
    background-color: #f8f9fa;
    color: #3273dc;
  }

  .admin-dropdown-menu button.active {
    background-color: #e8f0fe;
    color: #3273dc;
    font-weight: 500;
  }

  .auth-buttons {
    display: flex;
    gap: 10px;
  }

  .login-btn {
    background-color: white;
    border: 1px solid #333;
    color: #333;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.9rem;
  }

  .login-btn:hover {
    background-color: #f8f9fa;
  }

  .user-dropdown {
    position: relative;
  }

  .user-btn {
    display: flex;
    align-items: center;
    background-color: white;
    border: 1px solid #3273dc;
    color: #3273dc;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.9rem;
  }

  .dropdown-arrow {
    font-size: 0.8rem;
    margin-left: 8px;
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background-color: white;
    border: 1px solid #eee;
    border-radius: 4px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    width: 180px;
    margin-top: 8px;
    z-index: 1100;
  }

  .dropdown-menu button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 10px 15px;
    background: none;
    border: none;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    font-size: 0.9rem;
  }

  .dropdown-menu button:last-child {
    border-bottom: none;
  }

  .dropdown-menu button:hover {
    background-color: #f5f5f5;
    color: #3273dc;
  }


  .menu-btn {
    display: none;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }

  /* 모바일 메뉴 스타일 */
  .mobile-menu {
    display: none;
    position: fixed;
    top: 81px; /* 헤더 높이 */
    left: 0;
    width: 100%;
    background-color: white;
    border-top: 1px solid #e9ecef;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 99;
    max-height: calc(100vh - 81px);
    overflow-y: auto;
  }

  .mobile-nav ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .mobile-nav li {
    border-bottom: 1px solid #e9ecef;
  }

  .mobile-nav li:last-child {
    border-bottom: none;
  }

  .mobile-nav a {
    display: block;
    padding: 15px 20px;
    color: #333;
    text-decoration: none;
    font-weight: 500;
  }

  .mobile-nav a:hover,
  .mobile-nav a.active {
    color: #3273dc;
    background-color: #f8f9fa;
  }


  @media (max-width: 768px) {
    .desktop-nav, .auth-buttons {
      display: none;
    }

    .menu-btn {
      display: block;
    }

    .mobile-menu {
      display: block;
    }
  }
</style>